
    import { mapGetters } from 'vuex';    
    import $ from 'jquery';
    import Cookies from "js-cookie";
    import Utilities from '@/utils/utilities';
    import Vue from "vue";

    export default Vue.extend({ 
        name: "AuthBox",
        data() {
            return {
                username: "",
                password: "",
                loginError: "",
                loginExpanded: false,
            }
        },
        computed: {
            signupMobileText(): string {
                return this.loginExpanded ? "Hide Login Section" : "Sign into Str8 Sets | Sign up";
            },
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                currentPlayer: 'currentPlayer/currentPlayer'
            })
        },
        methods: {
            login(): Promise<any> {
                this.loginError = "";
                
                let authTokenVal = "";

                const creds = {
                    username: this.username,
                    password: this.password
                };
        
                const loginRequest = new Request("/api/login/", {
                    method: "POST",
                    cache: "no-cache",
                    body: JSON.stringify(creds), // data can be `string` or {object}!
                    headers: {
                        "Content-Type": "application/json",
                        'Accept': 'application/json'
                    }
                });
        
                return fetch(loginRequest)
                    .then(Utilities.handleAPIErrors) 
                    .then(r => r.json().then(data => ({ status: r.status, body: data })))
                    .then(loginData => {
                        authTokenVal = loginData.body.token;
                        Cookies.set("authtoken", authTokenVal, {
                            expires: 7
                        });
        
                        // Now go and get the user's player object and store it
                        return fetch("/api/user/", {
                            method: "GET",
                            cache: "no-cache",
                            headers: {
                                Authorization: "Token " + authTokenVal,
                                "Content-Type": "application/json",
                                'Accept': 'application/json'
                            }
                        });
                    })
                    .then(Utilities.handleAPIErrors) 
                    .then(r => r.json().then(data => ({ status: r.status, body: data })))
                    .then(userData => {
                        localStorage.setItem(
                            "CurrentPlayer",
                            JSON.stringify(userData.body.results[0].player_set[0])
                        );
                    
                        // Next step, look up the sport object and store the ID in local storage
                        return fetch("/api/sport/?name=tennis", {
                            method: "GET",
                            cache: "no-cache",
                            headers: {
                                Authorization: "Token " + authTokenVal,
                                "Content-Type": "application/json",
                                'Accept': 'application/json'
                            }
                        });
                    })
                    .then(Utilities.handleAPIErrors) 
                    .then(r =>  r.json().then(data => ({ status: r.status, body: data })))
                    .then(sportData => {
                        localStorage.setItem("TennisSportId", sportData.body.results[0].id);
                        window.location.href = "/clubs"; // reload to show logged in status and load new data
                    })
                    .catch(() => {
                        this.loginError = "Login failed, please try again";
                    });
            },
            logout() {
                Cookies.remove("authtoken");
                localStorage.removeItem("CurrentPlayer");
                window.location.href = "/";
            },
            toggleSignupMobile() {
                $("#login-section").slideToggle();  // long term goal: remove jQuery here!
                this.loginExpanded = !this.loginExpanded;
            },
        }
    })
